
<template>
    <ForgotPasswordComponent />
  </template>
  
  <script>
  import ForgotPasswordComponent from '@/components/auth/ForgotPasswordComponent.vue'; 

  export default {
    name: 'LoginView',
    components: {
      ForgotPasswordComponent
    },
    mounted() {
    window.scrollTo(0, 0);
    },
  }
  </script>
  
  <style scoped>
  
  </style>
  
